export const makeWordBlank = (word: string, lettersSelected: string[]) =>
  lettersSelected.join('') +
  '_ '.repeat(word.length - lettersSelected.length).trim();
